import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: row;
  a {
    text-decoration: none;
  }
  @media print {
    display: none !important;
  }
`



// WEBPACK FOOTER //
// ./src/components/ContentTab/styled.js